export const portfolio = [
  {
    name: "Onepane",
    body: "Sovereign AI agent control planes that give enterprise IT governance, safety, and cost control over AI agent fleets.",
  },
  {
    name: "Benev",
    body: "Physical AI: a device that makes every pair of glasses smart.",
  },
  {
    name: "Rushot",
    body: "Professional content creators on demand: book through the app, a creator arrives, shoots, edits, and delivers short-form video before your event wraps up.",
  },
  {
    name: "Srocco Ventures",
    body: "Practical generative AI solutions for businesses: consulting and implementation.",
  },
];

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="py-32 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-16 space-y-6">
          <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded">
            <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">Portfolio</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-foreground">
            Companies we work inside, not just fund
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {portfolio.map((company, i) => (
            <div
              key={company.name}
              className={`p-8 bg-secondary border-l-4 ${i % 2 === 0 ? "border-accent" : "border-primary"} hover:shadow-lg transition-shadow flex flex-col gap-4`}
            >
              <h3 className="text-3xl font-black text-foreground">{company.name}</h3>
              <p className="text-base text-foreground leading-relaxed flex-1">{company.body}</p>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-accent">
                Investor &amp; Operating Partner
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;